import Head from 'next/head'

import HouseOfMathLoader from './HouseOfMathLoader'

export default function SplashScreen({
  hideLogo,
  subtitle,
}: {
  hideLogo?: boolean
  subtitle?: string
}): React.ReactElement {
  return (
    <div className="fixed inset-0 bg-gray-off-white z-modal">
      <Head>
        <meta content="noindex" name="robots" />
      </Head>
      <HouseOfMathLoader hideLogo={hideLogo} subtitle={subtitle} />
    </div>
  )
}
